import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // tu peux mettre "auto" si tu veux un scroll instantané
    });
  }, [pathname]);

  return null;
}
